(function () {
  const root = document.querySelector('[data-blsm-builder]');
  if (!root) return;

  // Remove loading class and inline styles to show builder (prevents FOUC)
  root.classList.remove('blsm-builder--loading');
  root.style.opacity = '';
  root.style.visibility = '';

  // Detect Facebook/Instagram in-app browser and add class for extra bottom padding
  const ua = navigator.userAgent || '';
  if (/FBAN|FBAV|Instagram|FB_IAB|FBIOS|FB4A/.test(ua)) {
    document.documentElement.classList.add('blsm-inapp');
  }

  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => Array.from(el.querySelectorAll(sel));

  // ---------------------------
  // CONFIG
  // ---------------------------
  const SUB_DISCOUNT_PCT = 20;

  const REDIRECT_TO = '/checkout';

  // Auto-size thresholds
  const SIZES = [8, 12, 16];

  // ---------------------------
  // STATE
  // ---------------------------
  const state = {
    target: 0,
    items: {},        // vid -> qty
    purchase: 'sub',  // 'once' | 'sub'  (DEFAULT: subscription)
    freqWeeks: '4',
    bundleKey: null,
    editingBundleId: null  // Set when editing existing bundle
  };

  // ---------------------------
  // SESSION PERSISTENCE
  // ---------------------------
  const STORAGE_KEY = 'blsm_box_state';

  function saveState() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        target: state.target,
        items: state.items,
        purchase: state.purchase,
        freqWeeks: state.freqWeeks,
        ts: Date.now()
      }));
    } catch (e) { /* storage full or unavailable — silently ignore */ }
  }

  function loadSavedState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var saved = JSON.parse(raw);
      // Expire after 60 minutes to avoid stale selections
      if (Date.now() - saved.ts > 60 * 60 * 1000) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return saved;
    } catch (e) { return null; }
  }

  function clearSavedState() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // ---------------------------
  // ELEMENTS
  // ---------------------------
  // Helper to query across both root and the tray (which lives outside root)
  const tray = document.querySelector('[data-blsm-tray]');
  const $both = (sel) => [...$$(sel, root), ...(tray ? Array.from(tray.querySelectorAll(sel)) : [])];

  const els = {
    sizeBtns: $$('[data-box-size]'),
    cards: $$('[data-vid]'),

    selectedReads: $both('[data-blsm-selected]'),
    targetReads: $both('[data-blsm-target]'),

    totalReads: $both('[data-blsm-total]'),
    wasReads: $both('[data-blsm-was]'),
    savingsReads: $both('[data-blsm-savings]'),
    shippingBadges: $both('[data-blsm-shipping-badge]'),

    addBtns: $both('[data-blsm-add]'),

    purchaseRadios: $both('input[name="blsm_purchase"]'),
    freqWraps: $both('[data-blsm-freq]'),
    // two selects: panel + tray
    freqSelects: [$('#blsm_freq'), $('[data-blsm-freq-select]', document)].filter(Boolean),

    // Slots
    panelSlots: $('[data-blsm-slots="panel"]'),
    traySlots: $('[data-blsm-slots="tray"]', document),

    trayToggle: $('[data-blsm-tray-toggle]', document),
    trayPanel: $('[data-blsm-tray-panel]', document),
    trayLabel: $('[data-blsm-tray-label]', document)
  };

  // ---------------------------
  // Helpers
  // ---------------------------
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'blsm_' + Math.random().toString(16).slice(2) + Date.now().toString(16);
  }

  function fmtMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 959px)').matches;
  }

  // Preload panel thumbnail images so they appear instantly when added to box
  els.cards.forEach(card => {
    const img = card.dataset.img;
    if (img) {
      const preload = new Image();
      preload.src = img.replace(/width=\d+/, 'width=200');
    }
  });

  function countSelected() {
    return Object.values(state.items).reduce((a, b) => a + b, 0);
  }

  function onceDiscountPct(target) {
    // No discounts for one-time purchases - only free shipping for 12 & 16
    return 0;
  }

  function sumDiscountedCents(discountPct) {
    // Apply discount per-unit (rounded down per item), then sum — matches Shopify's calculation
    const POUCH_PRICE = 599;
    const discountedUnit = Math.round(POUCH_PRICE * (1 - discountPct / 100));
    let total = 0;
    Object.values(state.items).forEach(qty => {
      total += discountedUnit * qty;
    });
    return total;
  }

  function sumBaseCents() {
    // Use $5.99 per pouch as base price (599 cents)
    const POUCH_PRICE = 599;
    let total = 0;
    
    Object.values(state.items).forEach(qty => {
      total += POUCH_PRICE * qty;
    });
    
    return total;
  }

  // ---------------------------
  // Selling plan map - BUILD FROM ACTUAL PRODUCTS BEING USED
  // ---------------------------
  function buildPlanMapFromGroups() {
    // Instead of using the first product's selling plans,
    // aggregate selling plans from ALL products in the grid
    const allPlans = new Map(); // week -> selling_plan_id
    
    els.cards.forEach(card => {
      const productUrl = card.dataset.url;
      if (!productUrl) return;
      
      const handle = productUrl.split('/').pop().split('?')[0];
      // We'll need to fetch these - but we can also extract from page data
      
      // Check if card has data-selling-plans attribute (we'll add this in Liquid)
      const plansData = card.dataset.sellingPlans;
      if (plansData) {
        try {
          const plans = JSON.parse(plansData);
          plans.forEach(plan => {
            // Extract week number from plan name
            const match = plan.name.match(/(\d+)\s*week/i);
            if (match) {
              const weeks = match[1];
              if (!allPlans.has(weeks)) {
                allPlans.set(weeks, plan.id);
              }
            }
          });
        } catch (e) {
        }
      }
    });
    
    // Convert Map to object
    const map = Object.fromEntries(allPlans);
    
    // Fallback: if no plans found from cards, try the old method
    if (Object.keys(map).length === 0) {
      const node = document.querySelector('[data-blsm-planmap]');
      if (!node) return {};

      let groups;
      try { groups = JSON.parse(node.textContent); } catch { return {}; }
      if (!Array.isArray(groups)) return {};

      for (const g of groups) {
        const plans = (g && g.selling_plans) || [];
        for (const p of plans) {
          if (!p || !p.id || !p.name) continue;
          
          // Extract numeric ID from GID string or use direct number
          let numericId;
          if (typeof p.id === 'string' && p.id.includes('gid://')) {
            const match = p.id.match(/\/(\d+)$/);
            numericId = match ? parseInt(match[1], 10) : null;
          } else {
            numericId = parseInt(p.id, 10);
          }
          
          if (!numericId) continue;
          
          // Extract week number from plan name
          const m = String(p.name).match(/(\d+)/);
          if (!m) continue;
          const weeks = m[1];
          
          if (!map[weeks]) {
            map[weeks] = numericId;
          }
        }
      }
    }
    
    return map;
  }

  const planMap = buildPlanMapFromGroups();

  function getSellingPlanId() {
    if (state.purchase !== 'sub') return null;
    return planMap[state.freqWeeks] || null;
  }

  // ---------------------------
  // Size selection + auto-sizing
  // ---------------------------
  function setSizeSelectedUI(target) {
    els.sizeBtns.forEach(btn => {
      const t = parseInt(btn.dataset.boxSize, 10);
      btn.classList.toggle('is-selected', t === target);
      btn.setAttribute('aria-pressed', t === target ? 'true' : 'false');
    });
  }

  function coerceTargetFromSelectedCount(selected) {
    if (selected <= 8) return 8;
    if (selected <= 12) return 12;
    return 16;
  }

  // Trim items to match target count (remove most recently added)
  function trimItemsToTarget(target) {
    const currentSelected = countSelected();
    if (currentSelected <= target) return; // No need to trim
    
    const excess = currentSelected - target;
    let removed = 0;
    
    // Get all variant IDs sorted by when they were added (most recent first)
    // Note: JavaScript objects maintain insertion order
    const variantIds = Object.keys(state.items).reverse();
    
    // Remove items from most recent until we've removed enough
    for (const vid of variantIds) {
      if (removed >= excess) break;
      
      const qty = state.items[vid];
      if (qty <= excess - removed) {
        // Remove entire variant
        removed += qty;
        delete state.items[vid];
      } else {
        // Partially reduce quantity
        const toRemove = excess - removed;
        state.items[vid] -= toRemove;
        removed += toRemove;
      }
    }
  }

  function setTarget(newTarget, { resetItems = true } = {}) {
    state.target = newTarget;
    state.bundleKey = uuid();

    setSizeSelectedUI(state.target);

    if (resetItems) state.items = {};
    repaintAll();
    saveState();
  }

  function maybeAutoResizeBox() {
    const selected = countSelected();
    if (!selected) return;

    const ideal = coerceTargetFromSelectedCount(selected);
    // FIX: Only auto-resize UP, never down
    if (ideal > state.target) {
      // Preserve items; only change target (cap at 16 is built in)
      state.target = ideal;
      setSizeSelectedUI(state.target);
      paintTotalsAndCTAs();
      paintTrayLabel();

      // GA4 Tracking
      if (window.BlossomTracking) {
        BlossomTracking.boxSizeSelected(ideal, selected, 'auto');
      }
    }
  }

  // ---------------------------
  // Tile toggle (Add button <-> Qty)
  // ---------------------------
  function paintCard(card) {
    const vid = card.dataset.vid;
    const qty = state.items[vid] || 0;

    const add = card.querySelector('.blsm-card__add');
    const qtyWrap = card.querySelector('.blsm-card__qty');
    const qtyVal = card.querySelector('.blsm-card__qval');
    if (!add || !qtyWrap || !qtyVal) return;

    if (qty > 0) {
      add.hidden = true;
      qtyWrap.hidden = false;
      qtyVal.textContent = String(qty);
    } else {
      add.hidden = false;
      qtyWrap.hidden = true;
      qtyVal.textContent = '0';
    }
  }

  // ---------------------------
  // Slot rendering (Panel vs Tray)
  // ---------------------------
  function getSelectedList() {
    return Object.entries(state.items)
      .map(([vid, qty]) => {
        const card = els.cards.find(c => c.dataset.vid === vid);
        return {
          vid,
          qty,
          title: card ? card.dataset.title : 'Sauce',
          img: card ? (card.dataset.img || '') : ''
        };
      })
      .sort((a, b) => a.title.localeCompare(b.title));
  }

  function renderPanelSlots() {
    if (!els.panelSlots) return;

    if (!state.target) {
      els.panelSlots.innerHTML = `<div class="blsm-slots__empty">Choose a box size, then add sauce mixes from the left.</div>`;
      return;
    }

    const list = getSelectedList();
    if (list.length === 0) {
      els.panelSlots.innerHTML = `<div class="blsm-slots__empty">Add sauce mixes from the left to fill your box.</div>`;
      return;
    }

    // Desktop: Show thumbnails like mobile (no empty slots)
    els.panelSlots.innerHTML = list.map(s => {
      // Swap Shopify CDN width to 200 for crisper panel thumbnails on Retina displays
      const hiresImg = s.img ? s.img.replace(/width=\d+/, 'width=200') : '';
      return `
      <div class="blsm-panel-thumb" data-slot="${s.vid}">
        <div class="blsm-panel-thumb__imgwrap">
          ${hiresImg ? `<img src="${hiresImg}" alt="${escapeHtml(s.title)}" width="160" height="160" loading="lazy">` : `&nbsp;`}
        </div>
        <div class="blsm-panel-thumb__title">${escapeHtml(s.title)}</div>
        <div class="blsm-panel-thumb__qty">
          <button class="blsm-panel-thumb__btn" type="button" data-slot-dir="-1" data-slot-vid="${s.vid}">−</button>
          <span class="blsm-panel-thumb__val">${s.qty}</span>
          <button class="blsm-panel-thumb__btn" type="button" data-slot-dir="1" data-slot-vid="${s.vid}">+</button>
        </div>
      </div>
    `;
    }).join('');

    $$('.blsm-panel-thumb__btn', els.panelSlots).forEach(btn => {
      btn.addEventListener('click', () => {
        adjustQty(btn.dataset.slotVid, parseInt(btn.dataset.slotDir, 10));
      });
    });
  }

  function renderTrayThumbs() {
    if (!els.traySlots) return;

    if (!state.target) {
      els.traySlots.innerHTML = '';
      return;
    }

    const list = getSelectedList();
    const selected = countSelected();
    const remaining = Math.max(0, state.target - selected);

    const thumbs = [];

    // Selected thumbs
    list.forEach(s => {
      const thumbImg = s.img ? s.img.replace(/width=\d+/, 'width=200') : '';
      thumbs.push(`
        <div class="blsm-thumb" data-thumb="${s.vid}">
          <div class="blsm-thumb__imgwrap">
            ${thumbImg ? `<img src="${thumbImg}" alt="${escapeHtml(s.title)}" loading="lazy">` : ``}
          </div>
          <div class="blsm-thumb__title">${escapeHtml(s.title)}</div>
          <div class="blsm-thumb__qty">
            <button class="blsm-thumb__btn" type="button" data-thumb-dir="-1" data-thumb-vid="${s.vid}">−</button>
            <span class="blsm-thumb__val">${s.qty}</span>
            <button class="blsm-thumb__btn" type="button" data-thumb-dir="1" data-thumb-vid="${s.vid}">+</button>
          </div>
        </div>
      `);
    });

    // Placeholders: "Add a Flavor"
    for (let i = 0; i < remaining; i++) {
      thumbs.push(`
        <div class="blsm-thumb blsm-thumb--empty" aria-hidden="true">
          <div class="blsm-thumb__imgwrap">&nbsp;</div>
          <div class="blsm-thumb__emptytext">Add a Flavor</div>
        </div>
      `);
    }

    els.traySlots.innerHTML = thumbs.join('');

    // Wire +/- in tray
    $$('.blsm-thumb__btn', els.traySlots).forEach(btn => {
      btn.addEventListener('click', () => {
        adjustQty(btn.dataset.thumbVid, parseInt(btn.dataset.thumbDir, 10));
      });
    });
  }

  function renderSlots() {
    renderPanelSlots();
    renderTrayThumbs();
  }

  // ---------------------------
  // Tray label behavior
  // ---------------------------
  function paintTrayLabel() {
    if (!els.trayLabel) return;
    const selected = countSelected();
    const target = state.target || 0;

    // CHANGE 1: Remove "— Choose Your Frequency" when filled
    const base = `${selected}/${target} Flavors Selected`;
    els.trayLabel.textContent = base;
  }

  // ---------------------------
  // Auto-open tray when target is met (mobile only)
  // ---------------------------
  function maybeAutoOpenTray() {
    if (!isMobile()) return;
    if (!els.trayPanel || !els.trayToggle) return;
    
    const selected = countSelected();
    const target = state.target || 0;
    const filled = target > 0 && selected === target;
    
    // CHANGE 2: Auto-open tray when box is filled
    if (filled) {
      const isHidden = els.trayPanel.hasAttribute('hidden');
      if (isHidden) {
        els.trayPanel.removeAttribute('hidden');
        const chev = els.trayToggle.querySelector('.blsm-tray__chev');
        if (chev) chev.classList.add('blsm-tray__chev--open');
        const actionLabel = els.trayToggle.querySelector('[data-blsm-tray-action]');
        if (actionLabel) actionLabel.textContent = 'Keep Shopping';
      }
    }
  }

  // ---------------------------
  // Totals + CTA state
  // ---------------------------
  // Paint purchase option prices (in top right of each frequency box)
  function paintPurchasePrices() {
    const base = state.target ? sumBaseCents() : 0;
    
    // Subscription price (ALWAYS 20% off, per-unit then summed)
    const subDiscounted = state.target ? sumDiscountedCents(SUB_DISCOUNT_PCT) : 0;
    const subPriceContainers = $both('[data-blsm-purchase-price="sub"]');
    subPriceContainers.forEach(container => {
      const wasEl = container.querySelector('[data-blsm-price-was]');
      const nowEl = container.querySelector('[data-blsm-price-now]');
      
      // Subscription ALWAYS shows strikethrough (always discounted)
      if (wasEl) {
        wasEl.textContent = state.target ? fmtMoney(base) : '$0.00';
        wasEl.hidden = !state.target;
      }
      if (nowEl) {
        nowEl.textContent = state.target ? fmtMoney(subDiscounted) : '$0.00';
      }
    });
    
    // One-time price (may have discount for 12/16 packs)
    const onceDiscount = state.target ? onceDiscountPct(state.target) : 0;
    const hasOnceDiscount = onceDiscount > 0;
    const onceDiscounted = state.target ? sumDiscountedCents(onceDiscount) : 0;
    const oncePriceContainers = $both('[data-blsm-purchase-price="once"]');
    oncePriceContainers.forEach(container => {
      const wasEl = container.querySelector('[data-blsm-price-was]');
      const nowEl = container.querySelector('[data-blsm-price-now]');
      
      // One-time: ONLY show strikethrough if there's a discount
      if (wasEl) {
        wasEl.textContent = state.target ? fmtMoney(base) : '$0.00';
        wasEl.hidden = !hasOnceDiscount || !state.target;
      }
      if (nowEl) {
        nowEl.textContent = state.target ? (hasOnceDiscount ? fmtMoney(onceDiscounted) : fmtMoney(base)) : '$0.00';
      }
    });
  }

  function paintTotalsAndCTAs() {
    const selected = countSelected();
    const base = state.target ? sumBaseCents() : 0;

    const discountPct = state.target
      ? (state.purchase === 'sub' ? SUB_DISCOUNT_PCT : onceDiscountPct(state.target))
      : 0;

    const discounted = state.target ? sumDiscountedCents(discountPct) : 0;
    const savings = Math.max(0, base - discounted);

    // Counters
    els.selectedReads.forEach(n => (n.textContent = String(selected)));
    els.targetReads.forEach(n => (n.textContent = String(state.target || 0)));

    // Totals
    els.totalReads.forEach(n => (n.textContent = state.target ? fmtMoney(discounted) : '$—'));

    // Was price (with strikethrough) - ALWAYS show for subscriptions or when discount applies
    els.wasReads.forEach(n => {
      if (!state.target) {
        n.hidden = true;
        n.textContent = '';
        n.style.textDecoration = '';
      } else if (state.purchase === 'sub') {
        // Always show strikethrough for subscriptions
        n.hidden = false;
        n.textContent = fmtMoney(base);
        n.style.textDecoration = 'line-through';
      } else if (discountPct > 0) {
        // Show strikethrough for one-time with discount (12-pack, 16-pack)
        n.hidden = false;
        n.textContent = fmtMoney(base);
        n.style.textDecoration = 'line-through';
      } else {
        // No discount, hide strikethrough
        n.hidden = true;
        n.textContent = '';
        n.style.textDecoration = '';
      }
    });

    // Savings line
    els.savingsReads.forEach(n => {
      if (!state.target || discountPct === 0) {
        n.hidden = true;
        n.textContent = '';
      } else {
        n.hidden = false;
        n.textContent = `You save ${fmtMoney(savings)} (${discountPct}% off).`;
      }
    });

    // Free Shipping badge (show for 12-pack and 16-pack only)
    const showFreeShipping = state.target === 12 || state.target === 16;
    els.shippingBadges.forEach(badge => {
      badge.hidden = !showFreeShipping;
    });

    // CTA enablement + label
    const ready = state.target > 0 && selected === state.target;
    
    // For Appstle: button is enabled when box is full
    // For subscriptions, we just need to make sure a plan ID exists for the frequency
    let canCheckout = ready;
    if (state.purchase === 'sub') {
      // Verify we have a selling plan ID for this frequency
      const planId = APPSTLE_CONFIG.frequencyPlans[state.freqWeeks];
      if (!planId) {
        canCheckout = false;
      }
    }

    // Dynamic button text based on remaining flavors
    els.addBtns.forEach(btn => {
      btn.disabled = !canCheckout;
      
      if (ready) {
        btn.textContent = 'Checkout';
      } else {
        const remaining = state.target - selected;
        if (remaining > 0) {
          btn.textContent = `Add ${remaining} Flavor${remaining !== 1 ? 's' : ''} to Checkout`;
        } else {
          btn.textContent = 'Complete Your Box';
        }
      }
    });
    
    // Update purchase option prices
    paintPurchasePrices();
  }

  function repaintAll() {
    els.cards.forEach(paintCard);
    renderSlots();
    paintTotalsAndCTAs();
    paintTrayLabel();
    maybeAutoOpenTray();
  }

  // ---------------------------
  // Mutations
  // ---------------------------
  function adjustQty(vid, dir) {
    if (!state.target) return;

    const current = state.items[vid] || 0;
    const next = Math.max(0, current + dir);

    // Enforce max 16 flavors total
    if (dir > 0) {
      const selected = countSelected();
      if (selected >= 16) return;
    }

    if (next === 0) delete state.items[vid];
    else state.items[vid] = next;

    // GA4 Tracking: item added / removed
    if (window.BlossomTracking) {
      var trackCard = els.cards.find(function(c) { return c.dataset.vid === vid; });
      var trackName = trackCard ? trackCard.dataset.title : '';
      var newCount = countSelected();
      if (dir > 0) {
        BlossomTracking.boxBuilderItemAdded(trackName, 'sauce_mix', newCount);
      } else if (dir < 0) {
        BlossomTracking.boxBuilderItemRemoved(trackName, newCount);
      }
    }

    // Auto-resize box up/down based on total selected
    maybeAutoResizeBox();

    const card = els.cards.find(c => c.dataset.vid === vid);
    if (card) paintCard(card);

    renderSlots();
    paintTotalsAndCTAs();
    paintTrayLabel();
    maybeAutoOpenTray();
    saveState();
  }

  // ---------------------------
  // Ensure subscription option is on top (DOM reorder)
  // ---------------------------
  function reorderPurchaseRowsSubFirst() {
    const radios = els.purchaseRadios;
    // If Liquid already checked something, sync state from DOM before forcing defaults
    const initiallyChecked = els.purchaseRadios.find(r => r.checked);
    if (initiallyChecked) state.purchase = initiallyChecked.value === 'sub' ? 'sub' : 'once';

    radios.forEach(r => {
      const row = r.closest('.blsm-purchase__row');
      if (!row) return;
      const parent = row.parentElement;
      if (!parent) return;

      // only do once per parent
      if (parent.dataset.blsmSorted === '1') return;

      const rows = Array.from(parent.querySelectorAll('.blsm-purchase__row'));
      rows.sort((a, b) => {
        const ra = a.querySelector('input[name="blsm_purchase"]');
        const rb = b.querySelector('input[name="blsm_purchase"]');
        const va = ra ? ra.value : '';
        const vb = rb ? rb.value : '';
        if (va === vb) return 0;
        if (va === 'sub') return -1;
        if (vb === 'sub') return 1;
        return 0;
      });

      rows.forEach(x => parent.appendChild(x));
      parent.dataset.blsmSorted = '1';
    });
  }

  function syncPurchaseUI() {
    // Sync all duplicated radios
    els.purchaseRadios.forEach(r => {
      const shouldBeChecked = (r.value === state.purchase);
      r.checked = shouldBeChecked;
      
      // CRITICAL FIX: Force CSS :checked to work by adding data attribute
      if (shouldBeChecked) {
        r.setAttribute('data-checked', 'true');
      } else {
        r.removeAttribute('data-checked');
      }
    });

    // Show/hide all freq blocks (panel + tray)
    els.freqWraps.forEach(w => (w.hidden = state.purchase !== 'sub'));
  }

  // ---------------------------
  // Events
  // ---------------------------
  els.sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = parseInt(btn.dataset.boxSize, 10);
      const currentSelected = countSelected();
      
      if (target >= currentSelected) {
        // Sizing UP or equal: keep all items
        setTarget(target, { resetItems: false });
      } else {
        // Sizing DOWN: trim excess items (remove most recently added)
        trimItemsToTarget(target);
        setTarget(target, { resetItems: false });
      }

      // GA4 Tracking
      if (window.BlossomTracking) {
        BlossomTracking.boxSizeSelected(target, countSelected(), 'manual');
      }
    });
  });

  els.cards.forEach(card => {
    const vid = card.dataset.vid;

    const addBtn = card.querySelector('.blsm-card__add');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        if (!state.target) return alert('Choose a box size first.');
        adjustQty(vid, 1);
      });
    }

    $$('.blsm-card__qbtn', card).forEach(btn => {
      btn.addEventListener('click', () => {
        adjustQty(vid, parseInt(btn.dataset.dir, 10));
      });
    });
  });

  // Purchase radios
  els.purchaseRadios.forEach(r => {
    r.addEventListener('change', () => {
      state.purchase = r.value === 'sub' ? 'sub' : 'once';
      syncPurchaseUI();
      paintTotalsAndCTAs();
      saveState();
      // GA4 Tracking
      if (window.BlossomTracking) {
        BlossomTracking.subscriptionToggled(r.value === 'sub' ? 'subscribe' : 'one_time');
      }
    });
  });

  // Frequency selects (panel + tray)
  els.freqSelects.forEach(sel => {
    sel.addEventListener('change', () => {
      state.freqWeeks = sel.value;
      // Sync both selects
      els.freqSelects.forEach(s2 => { if (s2 !== sel) s2.value = sel.value; });
      paintTotalsAndCTAs();
      saveState();
    });
  });

  // Tray open/close
  if (els.trayToggle && els.trayPanel) {
    els.trayToggle.addEventListener('click', () => {
      const open = !els.trayPanel.hasAttribute('hidden');
      if (open) els.trayPanel.setAttribute('hidden', '');
      else els.trayPanel.removeAttribute('hidden');

      const chev = els.trayToggle.querySelector('.blsm-tray__chev');
      if (chev) {
        // Toggle class for CSS rotation
        if (open) {
          chev.classList.remove('blsm-tray__chev--open');
        } else {
          chev.classList.add('blsm-tray__chev--open');
        }
      }
      const actionLabel = els.trayToggle.querySelector('[data-blsm-tray-action]');
      if (actionLabel) {
        actionLabel.textContent = open ? 'View Box' : 'Keep Shopping';
      }
    });
  }

  // ---------------------------
  // Add to cart - APPSTLE APPROACH
  // ---------------------------
  
  // Appstle configuration
  const APPSTLE_CONFIG = {
    // Your Appstle selling plan IDs
    frequencyPlans: {
      '4': 1666744395,   // 4 week subscription
      '6': 1666777163,   // 6 week subscription
      '8': 1666809931,   // 8 week subscription
      '10': 1666842699   // 10 week subscription
    },
    
    // Appstle Build-A-Box reference IDs (from your screenshots)
    bundleRefs: {
      '8': 'nqcffvdu',   // 8-pack reference ID
      '12': 'eoql6qu4',  // 12-pack reference ID  
      '16': 'sfrp8kim'   // 16-pack reference ID
    }
  };
  
  async function addBundleToCart() {
    const selected = countSelected();
    if (!state.target || selected !== state.target) return;

    // GA4 Tracking: box_builder_completed
    if (window.BlossomTracking) {
      var discPct = state.purchase === 'sub' ? SUB_DISCOUNT_PCT : onceDiscountPct(state.target);
      var boxValueCents = sumDiscountedCents(discPct);
      BlossomTracking.boxBuilderCompleted(state.target, selected, boxValueCents / 100, state.purchase === 'sub');
    }

    const bundleRef = APPSTLE_CONFIG.bundleRefs[state.target];
    if (!bundleRef) {
      alert('Bundle configuration error. Please contact support.');
      return;
    }
    

    // Use existing bundle ID if editing, otherwise create new one
    const bundleId = state.editingBundleId || `bundle-${Date.now()}`;

    // If editing, remove old bundle first
    if (state.editingBundleId) {
      
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        
        const updates = {};
        cart.items.forEach((item, index) => {
          if (item.properties && item.properties._bundle_id === state.editingBundleId) {
            updates[index + 1] = 0;
          }
        });
        
        if (Object.keys(updates).length > 0) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
      } catch (error) {
        alert('Failed to update bundle. Please remove old bundle and try again.');
        return;
      }
    }

    // Build items array - Add each jar as INDIVIDUAL line item (quantity 1)
    // This allows customers to swap each jar separately in Appstle portal
    // Cart drawer will group them visually
    const items = [];
    
    Object.entries(state.items).forEach(([variantId, totalQuantity]) => {
      const card = els.cards.find(c => c.dataset.vid === variantId);
      if (!card || totalQuantity === 0) return;
      
      const flavorName = card.dataset.title;
      
      // Add each jar as a SEPARATE line item with quantity 1
      for (let i = 0; i < totalQuantity; i++) {
        // Build properties that Appstle recognizes
        const properties = {
          '_bundle_id': bundleId,
          '_bundle_size': String(state.target),
          '_bundle_locked': 'true',
          '_appstle_bundle': bundleRef,
          '_bundleId': bundleRef,
          '_jar_index': String(i + 1),
          '_flavor_name': flavorName,  // For visual grouping in cart
          '_total_flavor_qty': String(totalQuantity)  // Total qty of this flavor
        };
        
        const lineItem = {
          id: Number(variantId),
          quantity: 1,  // Always 1 - each jar is separate
          properties: properties
        };
        
        // Add subscription if selected
        if (state.purchase === 'sub') {
          const planId = APPSTLE_CONFIG.frequencyPlans[state.freqWeeks];
          if (planId) {
            lineItem.selling_plan = Number(planId);
            
            // Add Appstle subscription properties with underscores to hide them
            lineItem.properties['_shipping_interval_frequency'] = state.freqWeeks;
            lineItem.properties['_shipping_interval_unit_type'] = 'week';
            
          } else {
          }
        } else {
        }
        
        items.push(lineItem);
      }
    });
    
    if (items.length === 0) {
      alert('No items selected.');
      return;
    }
    



    // Add to cart
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!res.ok) {
        const text = await res.text();
        
        let errorMsg = 'Failed to add bundle.';
        try {
          const errorJson = JSON.parse(text);
          if (errorJson.description) errorMsg = errorJson.description;
        } catch (e) {}
        
        alert(errorMsg);
        return;
      }

      const data = await res.json();
      
      // Clear saved selections after successful add
      clearSavedState();
      
      // Redirect to cart
      window.location.href = REDIRECT_TO;
      
    } catch (error) {
      alert('Network error. Please try again.');
    }
  }

  els.addBtns.forEach(btn => btn.addEventListener('click', addBundleToCart));

  // ---------------------------
  // INIT (this is where your mobile overlap + defaults get fixed)
  // ---------------------------

  // Check for edit mode (URL parameters)
  function checkEditMode() {
    const urlParams = new URLSearchParams(window.location.search);
    const editBundleId = urlParams.get('edit');
    const editSize = urlParams.get('size');
    const editItems = urlParams.get('items');
    
    if (editBundleId && editSize && editItems) {
      
      // Store bundle ID for removal later
      state.editingBundleId = editBundleId;
      
      // Set box size
      const size = parseInt(editSize);
      if ([8, 12, 16].includes(size)) {
        setTarget(size, { resetItems: false });
      }
      
      // Parse items: "variantId:quantity,variantId:quantity"
      const itemPairs = editItems.split(',');
      itemPairs.forEach(pair => {
        const [variantId, quantity] = pair.split(':');
        if (variantId && quantity) {
          state.items[variantId] = parseInt(quantity);
        }
      });
      
      // Update UI to show restored selections
      repaintAll();
      
      // Scroll to show selections
      if (isMobile()) {
        const trayBar = $('.blsm-tray__bar', document);
        if (trayBar) {
          setTimeout(() => {
            trayBar.click(); // Open tray to show selections
          }, 500);
        }
      }
      
      return true;
    }
    
    return false;
  }

  // Prevent tray panel from ever blocking taps on load
  if (els.trayPanel) els.trayPanel.setAttribute('hidden', '');

  // Put subscription row on top everywhere
  reorderPurchaseRowsSubFirst();

  // Check if we're in edit mode
  const isEditMode = checkEditMode();
  
  if (!isEditMode) {
    // Try to restore from session
    var saved = loadSavedState();
    if (saved && saved.items && Object.keys(saved.items).length > 0) {
      // Validate saved variant IDs still exist on the page
      var validItems = {};
      Object.keys(saved.items).forEach(function(vid) {
        if (els.cards.find(function(c) { return c.dataset.vid === vid; })) {
          validItems[vid] = saved.items[vid];
        }
      });

      if (Object.keys(validItems).length > 0) {
        state.target = [8, 12, 16].indexOf(saved.target) !== -1 ? saved.target : 8;
        state.items = validItems;
        state.purchase = saved.purchase === 'once' ? 'once' : 'sub';
        state.freqWeeks = saved.freqWeeks || '4';
        state.bundleKey = uuid();
        setSizeSelectedUI(state.target);
      } else {
        // Saved items no longer valid — start fresh
        setTarget(8, { resetItems: true });
      }
    } else {
      // No saved state — default box size = 8
      setTarget(8, { resetItems: true });
    }
  }

  // Set purchase UI from state (handles both fresh + restored)
  syncPurchaseUI();

  // Ensure both selects match state
  els.freqSelects.forEach(sel => (sel.value = state.freqWeeks));

  repaintAll();

  // GA4 Tracking: fire box_builder_opened on page load
  if (window.BlossomTracking) {
    BlossomTracking.boxBuilderOpened();
  }

  // Keep tray label accurate on resize (debounced)
  function debounce(fn, ms) {
    let t;
    return function(...args) { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), ms); };
  }
  window.addEventListener('resize', debounce(() => {
    paintTrayLabel();
  }, 100));
})();

// ---------- PRODUCT INFO MODAL ----------
(function() {
  const modal = document.getElementById('product-modal');
  const modalBody = document.getElementById('product-modal-body');
  
  if (!modal || !modalBody) return;
  
  // ===== PRODUCT PAGE CACHE =====
  const _productCache = {};     // raw HTML cache
  const _processedCache = {};   // fully processed modal content cache

  // Fetch and parse product page HTML (with caching)
  async function fetchProductHTML(productUrl) {
    if (_productCache[productUrl]) return _productCache[productUrl];
    const response = await fetch(productUrl);
    const html = await response.text();
    _productCache[productUrl] = html;
    return html;
  }

  // Process raw HTML into ready-to-inject modal content (expensive — only do once per product)
  function processProductHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const mainContent = doc.querySelector('main#MainContent, main, .main-content');
    if (!mainContent) throw new Error('Could not find product content');
    
    const contentClone = mainContent.cloneNode(true);
    
    // Remove unwanted elements
    const unwantedSelectors = [
      'product-form',
      'form[action*="/cart/add"]',
      '.product-form__submit',
      '[name="add"]',
      'button[type="submit"]',
      '.shopify-payment-button',
      '.product__price',
      '.price',
      '.add-to-box-container',
      '.breadcrumbs',
      '[class*="breadcrumb"]',
      'a[href*="/products/"][href$="#"]',
    ];
    
    unwantedSelectors.forEach(selector => {
      contentClone.querySelectorAll(selector).forEach(el => el.remove());
    });
    
    // Extract inline styles from the product page
    const styles = Array.from(doc.querySelectorAll('style'))
      .map(style => style.outerHTML)
      .join('\n');
    
    return `${styles}<div class="blsm-modal__product-embed">${contentClone.innerHTML}</div>`;
  }

  // Get processed content (cache hit = instant)
  async function getProcessedContent(productUrl) {
    if (_processedCache[productUrl]) return _processedCache[productUrl];
    const html = await fetchProductHTML(productUrl);
    const processed = processProductHTML(html);
    _processedCache[productUrl] = processed;
    return processed;
  }

  // Prefetch on hover/touchstart for faster modal open
  document.addEventListener('pointerenter', function(e) {
    if (!e.target || !e.target.closest) return;
    const trigger = e.target.closest('[data-product-modal]');
    if (!trigger) return;
    const url = trigger.getAttribute('data-product-modal');
    if (url && !_productCache[url]) {
      fetchProductHTML(url).catch(() => {}); // silent prefetch
    }
  }, true);

  // Touchstart prefetch for mobile (pointerenter doesn't fire on tap)
  document.addEventListener('touchstart', function(e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest('[data-product-modal]');
    if (!trigger) return;
    var url = trigger.getAttribute('data-product-modal');
    if (url && !_productCache[url]) {
      fetchProductHTML(url).catch(function() {});
    }
  }, { passive: true });

  // Background prefetch AND pre-process all product pages after page settles
  // Only 6 SKUs so this is lightweight — makes every modal open instant
  (function prefetchAll() {
    function run() {
      var urls = [];
      document.querySelectorAll('[data-product-modal]').forEach(function(el) {
        var url = el.getAttribute('data-product-modal');
        if (url && urls.indexOf(url) === -1 && !_processedCache[url]) {
          urls.push(url);
        }
      });
      // Stagger fetches to avoid blocking other resources
      urls.forEach(function(url, i) {
        setTimeout(function() {
          getProcessedContent(url).catch(function() {});
        }, 1000 + (i * 300));
      });
    }
    // Wait for page to be fully interactive
    if (document.readyState === 'complete') {
      setTimeout(run, 1000);
    } else {
      window.addEventListener('load', function() { setTimeout(run, 1000); });
    }
  })();

  // Open modal when Product Info is clicked (use capture phase to intercept first)
  document.addEventListener('click', async function(e) {
    const trigger = e.target.closest('[data-product-modal]');
    if (!trigger) return;
    
    // Stop ALL event propagation to prevent other handlers (like search dialog)
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    const productUrl = trigger.getAttribute('data-product-modal');
    
    // GA4 Tracking: flavor modal opened
    if (window.BlossomTracking) {
      var card = trigger.closest('[data-vid]');
      var flavorName = card ? card.dataset.title : '';
      BlossomTracking.flavorModalOpened(flavorName);
    }

    // Check if content is already processed (cached) — if so, skip loading state
    var isCached = !!_processedCache[productUrl];

    // Show modal immediately
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    
    if (!isCached) {
      modalBody.innerHTML = '<div class="blsm-modal__loading">Loading...</div>';
    }
    modalBody.scrollTop = 0;
    
    // Close any open Dawn theme dialogs
    var dialogs = document.querySelectorAll('dialog[open], [role="dialog"][open]');
    dialogs.forEach(function(dialog) {
      if (dialog.close) dialog.close();
      dialog.removeAttribute('open');
      dialog.hidden = true;
    });

    try {
      var content = await getProcessedContent(productUrl);
      
      // Inject content
      modalBody.innerHTML = content;
      modalBody.scrollTop = 0;
      
      // Post-process: strip Dawn inline styles
      modalBody.querySelectorAll('.blsm-modal__product-embed *').forEach(function(el) {
        var cs = el.style;
        if (cs.paddingBottom || cs.aspectRatio || cs.minHeight) {
          cs.paddingBottom = '0px';
          cs.aspectRatio = 'auto';
          cs.minHeight = '0px';
          cs.height = 'auto';
        }
      });
      
      var SLIDER_SELECTORS = ['slider-component', '.slider', '.product__media-list', '.product__media-item'];
      modalBody.querySelectorAll('[style*="--ratio"], [style*="padding-bottom"]').forEach(function(el) {
        var isSlider = SLIDER_SELECTORS.some(function(sel) { return el.matches(sel); });
        if (isSlider) return;
        el.style.setProperty('--ratio', 'auto', 'important');
        el.style.paddingBottom = '0px';
        el.style.height = 'auto';
        el.style.overflow = 'visible';
      });

      // Mobile slider setup
      if (window.innerWidth < 960) {
        var sliderContainer =
          modalBody.querySelector('slider-component ul[id*="Slider-Gallery"]') ||
          modalBody.querySelector('slider-component .product__media-list') ||
          modalBody.querySelector('.product__media-list');
        if (sliderContainer) {
          sliderContainer.style.setProperty('overflow-x', 'auto', 'important');
          sliderContainer.style.setProperty('overflow-y', 'hidden', 'important');
          sliderContainer.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
          sliderContainer.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
          sliderContainer.style.setProperty('display', 'flex', 'important');
          sliderContainer.style.setProperty('flex-wrap', 'nowrap', 'important');
        }
      }

      // ===== MOBILE HERO ARROWS =====
      (function setupHeroArrows() {
        if (window.innerWidth > 959) return;
        var sliderComponent = modalBody.querySelector('.blsm-modal__product-embed slider-component');
        var mediaList = modalBody.querySelector('.blsm-modal__product-embed .product__media-list');
        if (!sliderComponent || !mediaList) return;

        // Inject arrow buttons
        var prevBtn = document.createElement('button');
        prevBtn.className = 'blsm-modal__hero-arrow blsm-modal__hero-arrow--prev';
        prevBtn.setAttribute('aria-label', 'Previous image');
        prevBtn.textContent = '‹';
        prevBtn.type = 'button';

        var nextBtn = document.createElement('button');
        nextBtn.className = 'blsm-modal__hero-arrow blsm-modal__hero-arrow--next';
        nextBtn.setAttribute('aria-label', 'Next image');
        nextBtn.textContent = '›';
        nextBtn.type = 'button';

        sliderComponent.appendChild(prevBtn);
        sliderComponent.appendChild(nextBtn);

        var slides = mediaList.querySelectorAll('.product__media-item, .slider__slide');
        var currentIndex = 0;

        function updateArrows() {
          prevBtn.disabled = currentIndex <= 0;
          nextBtn.disabled = currentIndex >= slides.length - 1;
        }

        function goTo(idx) {
          if (idx < 0 || idx >= slides.length) return;
          currentIndex = idx;
          slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          updateArrows();
          // Also sync thumbnails if they exist
          var thumbBtns = modalBody.querySelectorAll('.thumbnail-list button, [id*="Slider-Thumbnails"] button');
          thumbBtns.forEach(function(btn, i) {
            btn.classList.toggle('is-active', i === idx);
            if (i === idx) btn.setAttribute('aria-current', 'true');
            else btn.removeAttribute('aria-current');
          });
        }

        prevBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          goTo(currentIndex - 1);
        });
        nextBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          goTo(currentIndex + 1);
        });

        // Sync index on scroll (swipe)
        mediaList.addEventListener('scroll', debounce(function() {
          var scrollLeft = mediaList.scrollLeft;
          var width = mediaList.offsetWidth;
          var newIndex = Math.round(scrollLeft / width);
          if (newIndex !== currentIndex && newIndex >= 0 && newIndex < slides.length) {
            currentIndex = newIndex;
            updateArrows();
          }
        }, 100));

        updateArrows();
      })();

      // ===== RENDER REVIEW WIDGET =====
      // Uses hardcoded review data from __blsmReviewData (sourced from Judge.me CSV export)
      (function renderReviewWidget() {
        function esc(str) {
          return String(str)
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;');
        }
        const card = trigger.closest('[data-vid]');
        const rating = card ? parseFloat(card.dataset.reviewRating) || 0 : 0;
        const reviewCount = card ? parseInt(card.dataset.reviewCount) || 0 : 0;
        const productTitleLower = (card ? card.dataset.title || '' : '').toLowerCase();
        const reviewOffset = /shawarma/.test(productTitleLower) ? 0 : 0;
        const adjustedReviewCount = reviewCount + reviewOffset;
        const productTitle = card ? card.dataset.title || '' : '';
        const productId = card ? card.dataset.productId || '' : '';
        
        if (reviewCount === 0) return;
        
        // Get reviews from hardcoded data
        const reviewData = window.__blsmReviewData || {};
        const reviews = (reviewData[productId] || []).map(function(rev) {
          return { body: rev.body, rating: rev.rating, author: rev.author, product: productTitle };
        });
        
        // Remove broken Judge.me widgets from fetched content
        const embed = modalBody.querySelector('.blsm-modal__product-embed');
        if (!embed) return;
        
        embed.querySelectorAll(
          '.jdgm-carousel-wrapper, [id*="judgeme_product_reviews"], ' +
          '[id*="judge_me_reviews"], [data-jdgm-block-id], .jdgm-review-widget, ' +
          '.jdgm-rev-widg, .jdgm-widget, [class*="jdgm-full-rev"], ' +
          '[class*="jdgm-popup"], [class*="jdgm-carousel"]'
        ).forEach(function(el) { el.remove(); });
        
        // Star HTML helper
        function starsHTML(score, cls) {
          let html = '';
          const rounded = Math.round(score * 2) / 2;
          const full = Math.floor(rounded);
          const hasHalf = (rounded - full) === 0.5;
          for (let i = 1; i <= 5; i++) {
            if (i <= full) {
              html += '<span class="blsm-star blsm-star--full">\u2605</span>';
            } else if (i === full + 1 && hasHalf) {
              html += '<span class="blsm-star blsm-star--half">\u2605</span>';
            } else {
              html += '<span class="blsm-star blsm-star--empty">\u2606</span>';
            }
          }
          return '<span class="' + cls + '">' + html + '</span>';
        }
        
        const verifiedSVG = '<svg class="blsm-reviews__verified-icon jdgm-verified-checkmark" viewBox="0 0 20 20" style="width:20px;height:20px;fill:rgb(62,178,162);"><path d="M1.14026 0C0.510511 0 0 0.510511 0 1.14026V18.8599C0 19.4896 0.510511 20.0001 1.14026 20.0001H18.8597C19.4895 20.0001 20 19.4896 20 18.8599V11.3685C20 11.008 19.5606 10.8315 19.3112 11.0918L15.3614 15.2135C13.6736 16.9747 11.912 17.8504 10.0763 17.8407C8.25519 17.8454 6.52568 17.0288 4.8878 15.391C3.14847 13.6516 2.23211 11.7644 2.13874 9.72917C2.06539 7.84992 2.79892 6.0381 4.33936 4.29371C4.5345 4.07273 4.86976 4.0698 5.07804 4.27808L8.5462 7.74623C8.75271 7.95274 8.75486 8.28861 8.57448 8.51907C7.73628 9.59004 7.70456 10.5129 8.47933 11.2877C9.26203 12.0704 10.1356 11.9585 11.1 10.9521L19.8888 1.78078C19.9602 1.70632 20 1.60716 20 1.50403V1.14026C20 0.510511 19.4895 0 18.8597 0H1.14026Z"/></svg>';
        
        let slidesHTML = '';
        reviews.forEach(function(rev) {
          slidesHTML +=
            '<div class="blsm-reviews__slide">' +
              '<div class="blsm-reviews__body">' + esc(rev.body) + '</div>' +
              starsHTML(rev.rating, 'blsm-reviews__stars-small') +
              '<div class="blsm-reviews__author">' + esc(rev.author) + '</div>' +
              '<div class="blsm-reviews__product">' + esc(rev.product) + '</div>' +
            '</div>';
        });
        
        const widgetEl =
          '<section class="blsm-reviews">' +
            '<h3 class="blsm-reviews__title">Customers are saying</h3>' +
            '<div class="blsm-reviews__summary">' +
              starsHTML(rating, 'blsm-reviews__stars-large') +
              '<span class="blsm-reviews__rating-text">' + rating.toFixed(2) + ' \u2605 (' + adjustedReviewCount + ')</span>' +
              '<span class="blsm-reviews__verified">' + verifiedSVG + ' Verified</span>' +
            '</div>' +
            (reviews.length > 0 ?
              '<div class="blsm-reviews__carousel">' +
                '<div class="blsm-reviews__track" data-blsm-review-track>' + slidesHTML + '</div>' +
              '</div>' +
              (reviews.length > 1 ?
                '<div class="blsm-reviews__nav">' +
                  '<button data-blsm-review-prev aria-label="Previous review">\u2039</button>' +
                  '<button data-blsm-review-next aria-label="Next review">\u203A</button>' +
                '</div>' : '')
            : '') +
          '</section>';
        
        embed.insertAdjacentHTML('beforeend', widgetEl);
        
        if (reviews.length > 1) {
          let currentSlide = 0;
          const track = modalBody.querySelector('[data-blsm-review-track]');
          const prevBtn = modalBody.querySelector('[data-blsm-review-prev]');
          const nextBtn = modalBody.querySelector('[data-blsm-review-next]');
          
          function goToSlide(idx) {
            currentSlide = Math.max(0, Math.min(idx, reviews.length - 1));
            if (track) track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
            if (prevBtn) prevBtn.disabled = currentSlide === 0;
            if (nextBtn) nextBtn.disabled = currentSlide === reviews.length - 1;
          }
          
          if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide(currentSlide - 1); });
          if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide(currentSlide + 1); });
          goToSlide(0);
        }
      })();
      
      // ===== INJECT ADD TO BOX BUTTON =====
      // Use rAF to inject after the current paint cycle
      requestAnimationFrame(() => {
        (function injectAddToBoxButton() {
        const card = trigger.closest('[data-vid]');
        if (!card) {
          return;
        }
        
        const vid = card.dataset.vid;
        const available = card.dataset.available === 'true';
        
        // Find product description in modal (look for common selectors)
        const embed = modalBody.querySelector('.blsm-modal__product-embed');
        if (!embed) {
          return;
        }
        
        // Find the description container - try multiple selectors
        let descriptionContainer = embed.querySelector('.product__description') ||
                                   embed.querySelector('[class*="description"]') ||
                                   embed.querySelector('.product-single__description') ||
                                   embed.querySelector('.rte');
        
        
        // Build button via DOM (not innerHTML) so we can force styles that survive any cascade
        const actionsDiv = document.createElement('div');
        actionsDiv.className = 'blsm-card__actions blsm-modal__actions';
        actionsDiv.setAttribute('style', 'margin:24px auto!important;width:100%!important;max-width:300px!important;display:block!important;visibility:visible!important;opacity:1!important;position:relative!important;height:auto!important;overflow:visible!important;');

        const addBtn = document.createElement('button');
        addBtn.className = 'blsm-card__add blsm-modal__add';
        addBtn.type = 'button';
        addBtn.textContent = available ? 'Add to Box' : 'Sold Out';
        if (available) {
          addBtn.setAttribute('style', 'display:flex!important;visibility:visible!important;opacity:1!important;position:relative!important;width:100%!important;height:46px!important;min-height:46px!important;max-height:46px!important;box-sizing:border-box!important;pointer-events:auto!important;align-items:center!important;justify-content:center!important;');
        } else {
          addBtn.disabled = true;
          addBtn.setAttribute('style', 'display:flex!important;visibility:visible!important;opacity:0.5!important;position:relative!important;width:100%!important;height:46px!important;min-height:46px!important;max-height:46px!important;box-sizing:border-box!important;pointer-events:none!important;align-items:center!important;justify-content:center!important;cursor:not-allowed!important;');
        }

        const qtyDiv = document.createElement('div');
        qtyDiv.className = 'blsm-card__qty blsm-modal__qty';
        qtyDiv.hidden = true;
        qtyDiv.setAttribute('style', 'display:none!important;max-width:300px!important;width:100%!important;margin:0 auto!important;height:46px!important;min-height:46px!important;max-height:46px!important;box-sizing:border-box!important;padding:6px 12px!important;');
        qtyDiv.innerHTML = `
          <button class="blsm-card__qbtn blsm-modal__qbtn" type="button" data-dir="-1" style="display:inline-flex!important;visibility:visible!important;opacity:1!important;">−</button>
          <span class="blsm-card__qval blsm-modal__qval" style="display:inline-flex!important;visibility:visible!important;opacity:1!important;">1</span>
          <button class="blsm-card__qbtn blsm-modal__qbtn" type="button" data-dir="1" style="display:inline-flex!important;visibility:visible!important;opacity:1!important;">+</button>
        `;

        actionsDiv.appendChild(addBtn);
        actionsDiv.appendChild(qtyDiv);

        // Insert after the description text. We place it as a sibling after the
        // description container, then force-show it — no reliance on inherited styles.
        if (descriptionContainer) {
          descriptionContainer.parentNode.insertBefore(actionsDiv, descriptionContainer.nextSibling);
          // Walk up ancestors and ensure none are hiding our button
          let ancestor = actionsDiv.parentNode;
          while (ancestor && ancestor !== modalBody) {
            const cs = window.getComputedStyle(ancestor);
            if (cs.display === 'none') {
              ancestor.style.setProperty('display', 'block', 'important');
            }
            if (cs.visibility === 'hidden') {
              ancestor.style.setProperty('visibility', 'visible', 'important');
            }
            if (parseFloat(cs.opacity) === 0) {
              ancestor.style.setProperty('opacity', '1', 'important');
            }
            if (cs.overflow === 'hidden' && ancestor.scrollHeight > ancestor.clientHeight) {
              // Don't touch slider elements — they need overflow:auto for swipe scrolling
              const tag = ancestor.tagName && ancestor.tagName.toLowerCase();
              const isSlider = tag === 'slider-component' ||
                ancestor.classList.contains('slider') ||
                ancestor.classList.contains('product__media-list') ||
                ancestor.classList.contains('product__media-item');
              if (!isSlider) {
                ancestor.style.setProperty('overflow', 'visible', 'important');
              }
            }
            ancestor = ancestor.parentNode;
          }
        } else {
          // Fallback: try to find "ADD WATER & SIMMER" element
          const allElements = Array.from(embed.querySelectorAll('*'));
          const waterElement = allElements.find(el => {
            const text = el.textContent.trim();
            return text.includes('ADD WATER') && text.includes('SIMMER') && el.getBoundingClientRect().width > 0;
          });
          
          if (waterElement) {
            waterElement.parentNode.insertBefore(actionsDiv, waterElement);
          } else {
            embed.insertBefore(actionsDiv, embed.firstChild);
          }
        }
        
        setTimeout(() => {
          const btn = modalBody.querySelector('.blsm-modal__add');
          if (btn) {
            const rect = btn.getBoundingClientRect();
          }
        }, 100);
        
        // Log what we can find
        const testFind = modalBody.querySelector('.blsm-modal__add');
        const testFind2 = modalBody.querySelector('.blsm-modal__actions');
        const testFind3 = document.querySelector('.blsm-modal__actions');
        
        const modalAddBtn = modalBody.querySelector('.blsm-modal__add');
        const modalQty = modalBody.querySelector('.blsm-modal__qty');
        const modalQtyVal = modalBody.querySelector('.blsm-modal__qval');
        const modalQtyBtns = modalBody.querySelectorAll('.blsm-modal__qbtn');
        
        
        if (!modalAddBtn) {
          return;
        }
        
        // Get references to card buttons
        const cardQty = card.querySelector('.blsm-card__qty');
        const cardQtyVal = card.querySelector('.blsm-card__qval');
        const cardAddBtn = card.querySelector('.blsm-card__add');
        
        // Sync initial state from card
        if (cardQty && !cardQty.hidden) {
          // Card has quantity showing, sync to modal
          modalAddBtn.style.setProperty('display', 'none', 'important');
          modalAddBtn.hidden = true;
          modalQty.style.setProperty('display', 'flex', 'important');
          modalQty.hidden = false;
          modalQtyVal.textContent = cardQtyVal.textContent;
        }
        
        // Wire up modal Add button
        modalAddBtn.addEventListener('click', () => {
          if (!available) return;
          
          
          // Trigger the card's add button
          cardAddBtn.click();
          
          // Update modal UI after card updates
          setTimeout(() => {
            if (cardQty && !cardQty.hidden) {
              modalAddBtn.style.setProperty('display', 'none', 'important');
              modalAddBtn.hidden = true;
              modalQty.style.setProperty('display', 'flex', 'important');
              modalQty.hidden = false;
              modalQtyVal.textContent = cardQtyVal.textContent;
            }
          }, 50);
        });
        
        // Wire up modal quantity buttons
        modalQtyBtns.forEach(btn => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent any event bubbling
            
            const dir = parseInt(btn.dataset.dir);
            
            
            // Find and click the corresponding card button
            const cardQtyBtn = card.querySelector(`.blsm-card__qbtn[data-dir="${dir}"]`);
            if (cardQtyBtn) {
              cardQtyBtn.click();
              
              // Update modal UI after card updates
              setTimeout(() => {
                if (cardQty && !cardQty.hidden) {
                  modalQtyVal.textContent = cardQtyVal.textContent;
                } else {
                  // Card removed item, switch back to Add button
                  modalAddBtn.style.setProperty('display', 'block', 'important');
                  modalAddBtn.hidden = false;
                  modalQty.style.setProperty('display', 'none', 'important');
                  modalQty.hidden = true;
                }
              }, 50);
            }
          });
        });
        
      })();
      }); // end requestAnimationFrame
      
      // ===== SETUP THUMBNAIL CLICK HANDLERS =====
      setTimeout(() => {

        // --- STEP 1: On desktop, completely replace Dawn's <slider-component>
        // with a plain <div> so the custom element lifecycle never fires.
        if (window.innerWidth >= 960) {
          const sliderComps = modalBody.querySelectorAll('slider-component');
          sliderComps.forEach((sc) => {
            const plainDiv = document.createElement('div');
            plainDiv.innerHTML = sc.innerHTML;
            Array.from(sc.attributes).forEach(attr => {
              plainDiv.setAttribute(attr.name, attr.value);
            });
            sc.parentNode.replaceChild(plainDiv, sc);
          });
        }

        // --- STEP 2: Query everything from the updated DOM ---
        const sliderContainer =
          modalBody.querySelector('ul[id*="Slider-Gallery"]') ||
          modalBody.querySelector('.product__media-list');

        const sliderItems = sliderContainer
          ? Array.from(sliderContainer.querySelectorAll(':scope > li'))
          : [];

        const thumbnails = Array.from(modalBody.querySelectorAll(
          'button.thumbnail, [id*="Slide-thumbnails"] button'
        ));

        if (!thumbnails.length || !sliderItems.length) return;

        // Use window width to determine mobile vs desktop, NOT scroll overflow.
        // Dawn's CSS grid can create a 1px scrollWidth > clientWidth difference on desktop,
        // which caused the old check to wrongly take the mobile scroll branch.
        const isMobileView = window.innerWidth < 960;

        function updateActiveThumbnail(index) {
          thumbnails.forEach((t, i) => {
            t.classList.toggle('is-active', i === index);
            t.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }

        updateActiveThumbnail(0);

        if (isMobileView) {
          // MOBILE: intercept clicks and scroll manually
          thumbnails.forEach((thumb, index) => {
            thumb.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              updateActiveThumbnail(index);
              const target = sliderItems[index];
              if (target) sliderContainer.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
            }, { capture: true });
          });

          const swipeObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                const index = sliderItems.indexOf(entry.target);
                if (index >= 0) updateActiveThumbnail(index);
              }
            });
          }, { threshold: 0.5, root: sliderContainer });
          sliderItems.forEach(item => swipeObserver.observe(item));

        } else {
          // DESKTOP: Simple show/hide with inline styles

          function desktopShowSlide(index) {
            sliderItems.forEach((item, i) => {
              if (i === index) {
                item.removeAttribute('hidden');
                item.style.cssText = 'display:block!important;visibility:visible!important;opacity:1!important;position:relative!important;width:100%!important;';
              } else {
                item.style.cssText = 'display:none!important;';
              }
            });
          }

          desktopShowSlide(0);

          thumbnails.forEach((thumb, index) => {
            thumb.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              updateActiveThumbnail(index);
              desktopShowSlide(index);
            }, { capture: true });
          });
        }

      }, 300);
      
    } catch (error) {
      modalBody.innerHTML = '<div class="blsm-modal__loading">Error loading product. Please try again.</div>';
    }
  }, true); // Use capture phase to intercept clicks BEFORE other handlers
  
  // Close modal
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    modalBody.innerHTML = '<div class="blsm-modal__loading">Loading...</div>';
  }
  
  // Close on overlay click or close button
  modal.addEventListener('click', function(e) {
    if (e.target.closest('[data-modal-close]')) {
      closeModal();
    }
  });
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  // ---------------------------
  // JUDGE.ME FORMATTING
  // ---------------------------
  // Reformat Judge.me review text from "1 review" to "(1)"
  var _jdgmObserver = null;
  var _jdgmPaused = false;

  function formatJudgeMeReviews() {
    if (_jdgmPaused) return;
    _jdgmPaused = true;

    const reviewTexts = document.querySelectorAll('.jdgm-prev-badge__text');
    reviewTexts.forEach(el => {
      const text = el.textContent.trim();
      const match = text.match(/(\d+)\s+reviews?/i);
      if (match) {
        const card = el.closest('[data-vid]');
        const titleLower = (card ? card.dataset.title || '' : '').toLowerCase();
        const offset = /shawarma/.test(titleLower) ? 0 : 0;
        const adjusted = parseInt(match[1]) + offset;
        el.textContent = `(${adjusted})`;
      }
      // Reveal the text element (CSS hides it until formatted)
      el.classList.add('blsm-formatted');
      // Also reveal the parent badge container
      const badge = el.closest('.jdgm-preview-badge, .jdgm-widget');
      if (badge) badge.classList.add('blsm-formatted');
    });

    // Unpause after a tick so we don't re-trigger from our own changes
    setTimeout(function() { _jdgmPaused = false; }, 200);
  }

  // Run at multiple intervals to catch Judge.me's async rendering
  setTimeout(formatJudgeMeReviews, 500);
  setTimeout(formatJudgeMeReviews, 1500);
  setTimeout(formatJudgeMeReviews, 3000);

  // Watch for Judge.me injecting badges dynamically
  const catalogGrid = document.querySelector('[data-blsm-grid]');
  if (catalogGrid) {
    _jdgmObserver = new MutationObserver(debounce(function() {
      formatJudgeMeReviews();
    }, 150));
    _jdgmObserver.observe(catalogGrid, { childList: true, subtree: true });
  }  // ---------------------------
  // EQUALIZE CARD NAME HEIGHTS PER ROW
  // ---------------------------
  function equalizeCardNames() {
    const grid = document.querySelector('[data-blsm-grid]');
    if (!grid) return;

    const names = Array.from(grid.querySelectorAll('.blsm-card__name'));
    if (!names.length) return;

    // Reset heights first so we can measure natural height
    names.forEach(n => n.style.minHeight = '');

    // Group names by their top offset (same top = same row)
    const rows = {};
    names.forEach(n => {
      const top = Math.round(n.getBoundingClientRect().top);
      if (!rows[top]) rows[top] = [];
      rows[top].push(n);
    });

    // For each row, set all names to the tallest one's height
    Object.values(rows).forEach(row => {
      const maxH = Math.max(...row.map(n => n.offsetHeight));
      row.forEach(n => n.style.minHeight = maxH + 'px');
    });
  }

  // Run after fonts/images load and on resize (debounced)
  setTimeout(equalizeCardNames, 500);
  window.addEventListener('resize', debounce(equalizeCardNames, 100));



})();